"use strict";

var _taggedTemplateLiteral = require("/home/runner/work/prodigies-brochure/prodigies-brochure/node_modules/.pnpm/@babel+runtime@7.19.0/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

var _regeneratorRuntime = require("/home/runner/work/prodigies-brochure/prodigies-brochure/node_modules/.pnpm/@babel+runtime@7.19.0/node_modules/@babel/runtime/regenerator");

require("regenerator-runtime/runtime");

var _slicedToArray = require("/home/runner/work/prodigies-brochure/prodigies-brochure/node_modules/.pnpm/@babel+runtime@7.19.0/node_modules/@babel/runtime/helpers/slicedToArray");

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  body {\n    overflow: hidden !important;\n  }\n  .intercom-lightweight-app {\n    display: none !important;\n  }\n  .feature-web-fixed-container {\n    position: fixed;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    pointer-events: none;\n    z-index: 10000; // This should be above anything antd produces.\n    overflow-y: auto;\n    background: ", ";\n    > div {\n      pointer-events: all;\n    }\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Fullscreen = exports.FullscreenMode = exports.useFullscreenHandle = void 0;

var antd_1 = require("antd");

var fscreen_1 = __importDefault(require("fscreen"));

var react_1 = __importDefault(require("react"));

var react_dom_1 = __importDefault(require("react-dom"));

var styled_components_1 = require("styled-components");

function useFullscreenHandle() {
  var _this = this;

  var _react_1$default$useS = react_1.default.useState(false),
      _react_1$default$useS2 = _slicedToArray(_react_1$default$useS, 2),
      active = _react_1$default$useS2[0],
      setActive = _react_1$default$useS2[1];

  var node = react_1.default.useRef(null);
  react_1.default.useEffect(function () {
    var handleChange = function handleChange() {
      setActive(fscreen_1.default.fullscreenElement === node.current);
    };

    fscreen_1.default.addEventListener('fullscreenchange', handleChange);
    return function () {
      return fscreen_1.default.removeEventListener('fullscreenchange', handleChange);
    };
  }, []);
  var enter = react_1.default.useCallback(function () {
    return __awaiter(_this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;

              if (!fscreen_1.default.fullscreenElement) {
                _context.next = 9;
                break;
              }

              _context.next = 4;
              return fscreen_1.default.exitFullscreen();

            case 4:
              if (!node.current) {
                _context.next = 7;
                break;
              }

              _context.next = 7;
              return fscreen_1.default.requestFullscreen(node.current);

            case 7:
              _context.next = 12;
              break;

            case 9:
              if (!node.current) {
                _context.next = 12;
                break;
              }

              _context.next = 12;
              return fscreen_1.default.requestFullscreen(node.current);

            case 12:
              _context.next = 18;
              break;

            case 14:
              _context.prev = 14;
              _context.t0 = _context["catch"](0);
              console.warn('error opening fullscreen');
              console.warn(_context.t0);

            case 18:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[0, 14]]);
    }));
  }, []);
  var exit = react_1.default.useCallback(function () {
    return __awaiter(_this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              if (!(fscreen_1.default.fullscreenElement === node.current)) {
                _context2.next = 3;
                break;
              }

              _context2.next = 3;
              return fscreen_1.default.exitFullscreen();

            case 3:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));
  }, []);
  return react_1.default.useMemo(function () {
    return {
      active: active,
      enter: enter,
      exit: exit,
      node: node
    };
  }, [active, enter, exit]);
}

exports.useFullscreenHandle = useFullscreenHandle;
var FullscreenMode;

(function (FullscreenMode) {
  FullscreenMode[FullscreenMode["Fullscreen"] = 0] = "Fullscreen";
  FullscreenMode[FullscreenMode["Inline"] = 1] = "Inline";
})(FullscreenMode = exports.FullscreenMode || (exports.FullscreenMode = {}));

function Fullscreen(_ref) {
  var children = _ref.children,
      fullscreen = _ref.fullscreen,
      onChange = _ref.onChange;
  var fixedRef = react_1.default.useRef(document.createElement('div'));
  var wasFullscreenRef = react_1.default.useRef(fullscreen === true || fullscreen === FullscreenMode.Fullscreen);

  var _useFullscreenHandle = useFullscreenHandle(),
      node = _useFullscreenHandle.node,
      enter = _useFullscreenHandle.enter,
      exit = _useFullscreenHandle.exit,
      active = _useFullscreenHandle.active;

  react_1.default.useEffect(function () {
    if (wasFullscreenRef.current && !active) {
      onChange(false);
    }
  }, [active]);
  react_1.default.useEffect(function () {
    wasFullscreenRef.current = fullscreen === true || fullscreen === FullscreenMode.Fullscreen;

    if (wasFullscreenRef.current) {
      enter();
    } else {
      exit();
    }
  }, [fullscreen]);
  react_1.default.useEffect(function () {
    if (fullscreen === FullscreenMode.Inline) {
      fixedRef.current.className = 'feature-web-fixed-container';
      document.body.appendChild(fixedRef.current);
      return function () {
        document.body.removeChild(fixedRef.current);
      };
    }
  }, [fullscreen === FullscreenMode.Inline]);
  var content = react_1.default.createElement("div", {
    ref: node
  }, react_1.default.createElement(antd_1.ConfigProvider, {
    getPopupContainer: function getPopupContainer() {
      return node.current || document.body;
    }
  }, children, fullscreen === FullscreenMode.Inline ? react_1.default.createElement(FixedGlobalStyles, null) : null));
  return fullscreen === FullscreenMode.Inline ? react_dom_1.default.createPortal(content, fixedRef.current) : content;
}

exports.Fullscreen = Fullscreen;
var FixedGlobalStyles = (0, styled_components_1.createGlobalStyle)(_templateObject(), function (props) {
  return props.theme['@layout-body-background'];
});